import {z} from 'zod';

/**
 * Response schema for file metadata from storage service
 */
export const storageFileMetadataResponseSchema = z.object({
  id: z.string(),
  fileMetadata: z.object({
    contentType: z.string(),
    fileSize: z.number(),
    image: z
      .object({
        dimensions: z
          .object({
            width: z.number(),
            height: z.number(),
          })
          .optional(),
      })
      .optional(),
  }),
  status: z.string(),
});

export type StorageFileMetadataResponse = z.infer<typeof storageFileMetadataResponseSchema>;
